import { render, staticRenderFns } from "./spec.vue?vue&type=template&id=41d13b3b"
import script from "./spec.vue?vue&type=script&lang=js"
export * from "./spec.vue?vue&type=script&lang=js"
import style0 from "./spec.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports